import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { fieldForceHeadQuarterVersionList } from "../../../redux/actions/fieldForceAction";
import FieldForceHeadquarterVersionListTableData from "./fieldForceHeadquarterVersionListTableData";
import DownArrow from "../../../assets/filterArrowDown.svg";
import UpArrow from "../../../assets/filterArrowUp.svg";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../../../components/Pagination/number-pagination";

const FieldForceHeadQuarterVersionTable = ({ search, status, page_no }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [page, setPage] = useState(page_no ?? 1);
  const [headQuarterVersionListData, setHeadQuarterVersionListData] = useState(
    []
  );
  const [openStatus, setOpenStatus] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      fieldForceHeadQuarterVersionList(
        {
          page,
          search,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
        },
        onSuccess,
        onError
      )
    );
  }, [page, status, search, dispatch]);

  const onSuccess = (data) => {
    setLoading(false);
    setHeadQuarterVersionListData(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap ">
          <table className="main-table">
            <thead>
              <tr className="table-rows color_747f9e">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads" width={"10%"}>
                  Head Quarters ID
                </th>
                <th className="table-heads" width={"10%"}>
                  Head Quarters Name
                </th>
                <th className="table-heads" width={"10%"}>
                  State
                </th>
                <th className="table-heads" width={"10%"}>
                  District
                </th>
                <th
                  ref={componentRef}
                  className="table-heads text-nowrap"
                  width={"8%"}
                >
                  <span
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                    onClick={() => {
                      setOpenStatus(!openStatus);
                    }}
                  >
                    <span className={status ? "Medium_Purple fw_700" : ""}>
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" alt="v" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="active"
                            name="status"
                            value={"active"}
                            checked={status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/field-force/head-quarter/version-list?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active`
                              );
                            }}
                          />
                          <label
                            htmlFor="active"
                            className={
                              status === "active"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="Inactive"
                            name="status"
                            value={"inactive"}
                            checked={status === "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/field-force/head-quarter/version-list?page=1${
                                  search ?? ""
                                }&status=inactive`
                              );
                            }}
                          />
                          <label
                            htmlFor="Inactive"
                            className={
                              status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(`/field-force/head-quarter/version-list`);
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads" width={"10%"}>
                  Updated By
                </th>
                <th className="table-heads" width={"10%"}>
                  Updated Date
                </th>
                <th className="table-heads" width={"10%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : headQuarterVersionListData?.headQuarters?.length > 0 ? (
                <>
                  {headQuarterVersionListData?.headQuarters?.map(
                    (data, index) => (
                      <FieldForceHeadquarterVersionListTableData
                        search={search}
                        data={data}
                        key={index}
                        index={index}
                        currentPage={
                          headQuarterVersionListData?.pagination?.currentPage
                        }
                        fieldForceHeadQuarterVersionList={
                          fieldForceHeadQuarterVersionList
                        }
                      />
                    )
                  )}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {headQuarterVersionListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={headQuarterVersionListData?.pagination?.currentPage}
              totalPages={headQuarterVersionListData?.pagination?.totalPages}
              path={"/field-force/head-quarter/version-list"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default FieldForceHeadQuarterVersionTable;
